if (typeof loadeMoreSlider_G === 'undefined') {
	globalThis.loadeMoreSlider_G = null;
}

(function () {
	const limitMobileSlides = (slider) => {
		if (!window.matchMedia("(max-width: 749px)").matches) return;

		const slides = slider.querySelectorAll(".swiper-wrapper > .swiper-slide");
		slides.forEach((slide, index) => {
			if (index > 2) slide.remove();
		});
	};

	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		sliders.forEach((slider, index) => {
			if (slider?.swiper) return;
			limitMobileSlides(slider);

			let nextEl = slider.querySelector(".product-button-group .swiper-button-next");
			let prevEl = slider.querySelector(".product-button-group .swiper-button-prev");
			if (dir === 'rtl') {
				[nextEl, prevEl] = [prevEl, nextEl];
			}

			const productSlider = new Swiper(slider, {
				speed: 360,
				slidesPerView: 1,
				watchOverflow: true,
				grabCursor: true,
				resistanceRatio: 0.75,
				preventClicks: true,
				preventClicksPropagation: true,
				pagination: {
					el: slider.querySelector(".product-pagination .swiper-pagination"),
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
			});
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
